module.exports = __webpack_public_path__ + "img/bjzhuanjia.36c0683c.png";